import { Controller } from '@hotwired/stimulus'

export default class PasswordController extends Controller {
  static targets = ['iconErrored', 'iconValidated', 'charactersMessage', 'specialCharacterMessage']

  validate (e) {
    const password = e.target.value
    const hasEnoughCharacters = password.length >= 8
    const hasSpecialCharacter = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(password)

    this.#updateMessageState(hasEnoughCharacters, hasSpecialCharacter)
    this.#updateIconState(hasEnoughCharacters, hasSpecialCharacter)
  }

  #updateMessageState (hasEnoughCharacters, hasSpecialCharacter) {
    if (hasEnoughCharacters) {
      this.#isValid(this.charactersMessageTarget)
    } else {
      this.#isInvalid(this.charactersMessageTarget)
    }

    if (hasSpecialCharacter) {
      this.#isValid(this.specialCharacterMessageTarget)
    } else {
      this.#isInvalid(this.specialCharacterMessageTarget)
    }
  }

  #updateIconState (hasEnoughCharacters, hasSpecialCharacter) {
    if (hasEnoughCharacters) {
      this.#showIcon(this.iconValidatedTargets[0])
      this.#hideIcon(this.iconErroredTargets[0])
    } else {
      this.#hideIcon(this.iconValidatedTargets[0])
      this.#showIcon(this.iconErroredTargets[0])
    }

    if (hasSpecialCharacter) {
      this.#showIcon(this.iconValidatedTargets[1])
      this.#hideIcon(this.iconErroredTargets[1])
    } else {
      this.#hideIcon(this.iconValidatedTargets[1])
      this.#showIcon(this.iconErroredTargets[1])
    }
  }

  #isValid (target) {
    target.classList.remove('text-red-400')
    target.classList.add('text-gray-600')
  }

  #isInvalid (target) {
    target.classList.remove('text-gray-600')
    target.classList.add('text-red-400')
  }

  #showIcon (icon) {
    icon.classList.remove('hidden')
  }

  #hideIcon (icon) {
    icon.classList.add('hidden')
  }
}
